import $ from 'jquery';

/*
 * Create a dropdown menu whose items open when clicked 
 *
 * Adds the attribute 'open' to the parent menu item when a submenu is open.
 * 
 * Assumes the default Wordpress menu classes are used.
 */

class MobileMenu {
    constructor({
        menu,
        button,
        closeArea = null,
        desktopMenu = null,
    }) {
        this.menu = $(menu)
        this.button = $(button)
        this.closeArea = $(closeArea)
        this.desktopMenu = $(desktopMenu)
        this.isOpen = false;

        this.button.on('click', this.toggle.bind(this));
        $(window).on('resize', this.onResize.bind(this));
        this.menu.on('keydown', this.keyPress.bind(this));

        if (this.desktopMenu) {
            this.onResize();
        }

        if (closeArea) {
            $(closeArea).on('click', this.close.bind(this));
            $(closeArea).hide();
        }
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        $('html').css('overflow', 'hidden');
        this.button.attr('open', 'true');
        this.menu.attr('open', 'true');
        this.menu.attr('aria-expanded', true);
        this.closeArea?.show();
        this.closeArea?.trigger('focus');
        this.isOpen = true;
    }

    close() {
        $('html').css('overflow', 'auto');
        this.button.removeAttr('open');
        this.button.trigger('focus');
        this.menu.removeAttr('open');
        this.menu.attr('aria-expanded', false);
        this.closeArea?.hide();
        this.isOpen = false;
    }

    keyPress(e) {
        switch (e.which) {
            case 27: // esc
                this.close();
                break;
        }
    }

    // only works one way for now (i.e. converts to mobile menu if overflows, but will never convert back)
    onResize() {
        if (this.desktopMenu.css('display') !== 'none') {
            const container = this.menu.parent()[0];

            if (container.offsetWidth < container.scrollWidth) {
                console.log('header is overflowing');
                this.desktopMenu.css('display', 'none');
                this.menu.css('display', 'flex');
                this.button.css('display', 'block');
            }
        }
    }
}

export default MobileMenu;
